module.exports = __webpack_public_path__ + "img/stock1.ef00a5af.png";